import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Footer from '../components/Footer/Footer';
import Recentprojectdetails from '../components/Recentprojectdetails/Recentprojectdetails';
import Pagetop from '../components/Pagetop/Pagetop';

class Recentprojectdetailspage extends Component {
    constructor({match}){
        super();
        this.state={
            Recentprojectdetailsid:match.params.projectId,
            ProjectPassedName:match.params.projectName
        }
    }
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Project details" />
                <Pagetop  title={this.state.ProjectPassedName}/>           
                <Recentprojectdetails id={this.state.Recentprojectdetailsid}/>
                <Footer/>
                
            </div>
        );
    }
}

export default Recentprojectdetailspage;